export default __webpack_public_path__ + "static/media/createDelpoyIcon.37092e1c.svg";